import { useState, useEffect } from 'react';

/**
 * Custom hook that returns whether the specified media query matches
 * @param query The media query to check
 * @returns Whether the media query matches
 */
const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    // Initial check
    setMatches(media.matches);
    
    // Define a callback function
    const listener = (e: MediaQueryListEvent) => {
      setMatches(e.matches);
    };
    
    // Add the listener
    media.addEventListener('change', listener);
    
    // Clean up
    return () => {
      media.removeEventListener('change', listener);
    };
  }, [query]);

  return matches;
};

export default useMediaQuery; 